module.exports = __webpack_public_path__ + "img/crown-active.72fd2e24.svg";